module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "mobxReact"
// module id = 10
// module chunks = 1 2